import React, { useState, useEffect,useContext } from "react";

//import css
import "./Mid-Section-Mobile.scss";

//import components
import MonthYearPicker from "../../Payments/Mobile-and-Tablet/MonthPicker.jsx";
// import Modal from "./TenantModal.jsx";
import SummaryCard from "./SummaryCard.jsx";

//import icons
import { IoIosAdd } from "react-icons/io";
import { CgArrowsExchange } from "react-icons/cg";
import { IoPersonRemoveOutline } from "react-icons/io5";
import { IoPersonAddOutline } from "react-icons/io5";
import TenantsList from "./TenantsList.jsx";
import TenantModificationModal from "./TenantModal.jsx";

//import context
import { MyContext } from "../../../../tenantsDashContext.jsx";


//imports for user data
import { useSelector, useDispatch } from "react-redux";

import { getProperty } from "../../../../redux/slices/sliceActions";

const MidSectionTenants = () => {
  //data from context
  const { curerntYear,currentMonth, monthNames,selectedDate,setSelectedDate } = useContext(MyContext);


  const dispatch = useDispatch();
  const { user, profile, tenants } = useSelector(
    (state) => state.landlordslice
  );
  const token = user?.accessToken;
  const id = user?.user?.user_id;
  const property_id = user?.user?.propertyId;

  const [percentageOccupied, setPercentageOccupied] = useState(0);
  const [percentageVacant, setPercentageVacant] = useState(0);
  const [occupiedHouses, setOccupiedHouses] = useState(0);
  const [vacantHouses, setVacantHouses] = useState(0);

  const [latestInvoice, setLatestInvoice] = useState([]);
  const [paymentProgress, setPaymentProgress] = useState([]);

  useEffect(() => {
    // console.log("muimi", profile);
    setPercentageOccupied(
      (profile.occupiedHouses / profile.totalHouses) * 100 || 0
    );
    setPercentageVacant(
      ((profile.totalHouses - profile.occupiedHouses) / profile.totalHouses) *
        100 || 0
    );
    setOccupiedHouses(profile.occupiedHouses);
    setVacantHouses(profile.totalHouses - profile.occupiedHouses);

    setLatestInvoice(profile.unpaidInvoices);
    setPaymentProgress(profile.paidInvoices?.[0]);

    dispatch(getProperty({ id: property_id, token }));
  }, [profile]);

  const [showModal, setShowModal] = useState(false);
  const [action, setAction] = useState("");
  const [tenantData, setTenantData] = useState({});

  const handleShowModal = (actionType) => {
    setAction(actionType);
    setShowModal(true);
  };

  return (
    <div className="caretaker-tenants-mobile">
      <div className="title-date-and-property">
        <div className="title">Select</div>
        <div className="date-and-property">
          <MonthYearPicker
            selectedDate={selectedDate}
            setSelectedDate={setSelectedDate}
          />
          <div className="apartment">
            <select
              id="apartment-select"
              name="apartment"
              className="apartment-dropdown"
            >
              <option value="apartment1">Apartment 1</option>
              <option value="apartment2">Apartment 2</option>
              <option value="apartment3">Apartment 3</option>
            </select>
          </div>
        </div>
      </div>
      <div className="summery-card-container">
        <SummaryCard
          dataInCard={{
            occupiedHouses,
            vacantHouses,
            percentageOccupied,
            percentageVacant,
          }}
        />
      </div>
      <div className="options-conatiner">
        <div className="title">Actions</div>
        <div className="options">
          <div
            className="individual-option"
            onClick={() => handleShowModal("create new tenant")}
          >
            <div className="icon-circle">
              <IoPersonAddOutline fontSize={20} />
            </div>
            <div className="card-title">Add</div>
          </div>
          <div
            className="individual-option"
            onClick={() => handleShowModal("delete tenant")}
          >
            <div className="icon-circle">
              <IoPersonRemoveOutline />
            </div>
            <div className="card-title">Remove</div>
          </div>
          <div
            className="individual-option"
            onClick={() => handleShowModal("move tenant")}
          >
            <div className="icon-circle">
              <CgArrowsExchange fontSize={20} />
            </div>
            <div className="card-title">Re-locate</div>
          </div>
        </div>
      </div>
      <div className="tenants-list-container">
        <div className="title">Tenant List</div>
        <TenantsList
          handleShowModal={handleShowModal}
          setTenantData={setTenantData}
        />
      </div>
      {showModal && (
        <TenantModificationModal
          setShowPay={setShowModal}
          fieldToShow={action}
          tenantData={tenantData}
          setTenantData={setTenantData}
        />
      )}
    </div>
  );
};

export default MidSectionTenants;
